import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Menu from './components/Menu/Menu';
import Home from './components/Home/Home';
import About from './components/About/About';
//import CV from './components/CV/CV';
import Contact from './components/Contact/Contact';
import PortfolioFeed from './components/Portfolio/PortfolioFeed';
import SingleProject from './components/Portfolio/SingleProject';
import Services from './components/Services/Services';
//import Project from './components/Portfolio/Project/Project';
//import ComingSoon from './components/ComingSoon/ComingSoon';
import NotFound from './components/NotFound/NotFound';
import Footer from './components/Footer/Footer';
import BlogFeed from './components/Blog/BlogFeed';
import SinglePost from './components/Blog/SinglePost';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';


function App() {
  return (
    <div>
      <HelmetProvider>        
      <Router>
        <Menu />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />

          {/* Blog Routes */}
          <Route path="/blog" element={<BlogFeed />} />
          <Route path="/blog/:slug" element={<SinglePost />} />
            
          {/* Portfolio Routes */}
          <Route path="/portfolio" element={<PortfolioFeed />} />
          <Route path="/portfolio/:slug" element={<SingleProject />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>
      </HelmetProvider>
    </div>
  );
}

export default App;

//<Route path="/cv" element={<CV />} />